import { c as _c } from "react/compiler-runtime";
import { Icon, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { Alert } from '@repo/ui/icons';
interface TextErrorProps {
  message: string;
  messageTooltip: string;
}
export const TextError = t0 => {
  const $ = _c(8);
  const {
    message,
    messageTooltip
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon icon={<Alert />} className="text-destructive-foreground" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== message) {
    t2 = <TooltipTrigger asChild={true}><div className="gap-2xs flex items-center">{t1}<span className="text-3xs text-destructive-foreground leading-normal">{message}</span></div></TooltipTrigger>;
    $[1] = message;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== messageTooltip) {
    t3 = <TooltipContent>{messageTooltip}</TooltipContent>;
    $[3] = messageTooltip;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <Tooltip>{t2}{t3}</Tooltip>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};